<header class="login-hdr">
  <img class="cfep-logo" src="assets/images/CFEP-logo.png" alt="cfep-logo" />
  <img *ngIf="!!cobrandedLogo" class="cfep-logo" [src]="cobrandedLogo" alt="cobranded-logo" />
</header>
